import React from 'react';
import { ProductMetadata } from './ProductMetadata';
import ProductSocialShare from '@/components/product/product-social-share';

interface ProductMetadataSectionProps {
  product: any;
  className?: string;
}

export const ProductMetadataSection: React.FC<ProductMetadataSectionProps> = ({
  product,
  className,
}) => {
  return (
    <div
      className={`rounded-lg border border-gray-100 p-4 dark:border-dark-400 ${
        className || ''
      }`}
    >
      <ProductMetadata product={product} />

      <ProductSocialShare
        productSlug={product.slug}
        size="small"
        title="Share"
        className="mt-4 border-t border-gray-100 pt-4 dark:border-dark-400"
      />
    </div>
  );
};
